<div class="d-flex justify-content-between mb-2">
    <div>
        TOT: {{full_count}}
    </div>
    <div>
        <button
            *ngIf="page > 0"
            type="button"
            nbButton
            (click)="page = page - 1"
        >
        </button> Pagina: {{ (page + 1) }} [ {{ (first_index_items + 1) }} --- {{ (last_index_items ) }} ] <button
            *ngIf="(page + 1) * limit < full_count "
            type="button"
            nbButton
            (click)="page = page + 1"
        >
        </button>
    </div>
</div>

<table class="table">
    <thead>
        <tr>
            <th scope="col">Data</th>
            <th scope="col">Consultorio</th>
            <th scope="col">Numero Libretto</th>
            <th scope="col">Cartaceo</th>
            <th scope="col">Id Utente</th>
            <th
                scope="col"
                *ngIf="show_nome"
            >Nome</th>
            <th
                scope="col"
                *ngIf="show_cognome"
            >Cognome</th>
            <th
                scope="col"
                *ngIf="show_codice_fiscale"
            >Codice Fiscale</th>
            <th
                scope="col"
                *ngIf="show_cup && isSuperAdmin"
            >Prenotazioni Cup</th>
            <th scope="col">Stato Gravidanza</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let entry of items">
            <td>{{entry.createdAt | date: 'dd-MM-yyyy'}} </td>
            <td>{{entry.descr_consultorio}} </td>
            <td><a
                    [routerLink]="['../libretto-gravidanza']"
                    [queryParams]="{codice_libretto: entry.codice_libretto}"
                >{{entry.codice_libretto }}</a> </td>
            <td class="text-center">{{entry.libretto_cartaceo ? "SI" : "NO" }} </td>
            <td><a
                    [routerLink]="['../libretto-gravidanza']"
                    [queryParams]="{cod_fiscale: entry.cod_fiscale}"
                >{{entry.utente_id }}</a></td>
            <td *ngIf="show_nome">{{entry.nome}} </td>
            <td *ngIf="show_cognome">{{entry.cognome}} </td>
            <td *ngIf="show_codice_fiscale"><a
                    [routerLink]="['../libretto-gravidanza']"
                    [queryParams]="{cod_fiscale: entry.cod_fiscale}"
                >{{entry.cod_fiscale}} </a></td>
            <td *ngIf="show_cup && isSuperAdmin"><a
                    [routerLink]="['../prescrizioni_cup']"
                    [queryParams]="{cod_fiscale: entry.cod_fiscale}"
                >{{entry.utente_id }}</a></td>
            <td>{{statoGravidanza(entry.stato_gravidanza)}} </td>
        </tr>
    </tbody>
</table>

<div class="d-flex justify-content-between mt-2">
    <div>
        TOT: {{full_count}}
    </div>
    <div>
        <button
            *ngIf="page > 0"
            type="button"
            nbButton
            (click)="page = page - 1"
        >
        </button> Pagina: {{ (page + 1) }} [ {{ (first_index_items + 1) }} --- {{ (last_index_items ) }} ] <button
            *ngIf="(page + 1) * limit < full_count "
            type="button"
            nbButton
            (click)="page = page + 1"
        >
        </button>
    </div>
</div>
